import {
  Box,
  Heading,
  PageBlock,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';

import { createDotNetLinkUrl } from 'src/utils';

import headerBannerImage from './packagesPageImages/header-banner.jpg';

import * as styles from './HeaderBanner.css';

export const HeaderBanner = () => (
  <Box className={styles.banner} data={{ testid: 'packages-header-banner' }}>
    <PageBlock width="large">
      <Box
        className={styles.card}
        background="surface"
        borderRadius="large"
        padding={{ mobile: 'none', desktop: 'large' }}
      >
        <Stack space="large">
          <Stack space="small">
            <Heading level="1" align={{ mobile: 'center', desktop: 'left' }}>
              Sell your business on SEEK Business
            </Heading>

            <Text
              align={{ mobile: 'center', desktop: 'left' }}
              data={{ testid: 'packages-header-description' }}
            >
              Sell with confidence, backed by 20 years of business-for-sale
              experience.
            </Text>
          </Stack>

          <Text
            size="small"
            align={{ mobile: 'center', desktop: 'left' }}
            data={{ testid: 'packages-franchisor-broker-message' }}
          >
            Are you a franchisor or broker?{' '}
            <TextLink href={createDotNetLinkUrl('/contact-us')} hitArea="large">
              Contact us
            </TextLink>
            .
          </Text>
        </Stack>
      </Box>
    </PageBlock>

    <Box className={styles.imageContainer}>
      <img src={headerBannerImage} alt="" className={styles.image} />
    </Box>
  </Box>
);
